<ion-header>
  <ion-toolbar mode="md"
               color="dark">
    <ion-buttons slot="start">
      <ion-button *ngIf="view === 'manual' || view ==='summary'"
                  mode="md"
                  color="orange"
                  fill="solid"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="onBack()">
        <ion-icon name="arrow-back-outline"></ion-icon>
        Back
      </ion-button>
    </ion-buttons>
    <ion-title>Gift Card</ion-title>
    <ion-buttons slot="end">
      <ion-button mode="md"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="onCloseModal()">Close</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content fullscreen>
  <div class="gift-card-payment-modal">
    <div class="gift-card-payment-modal__scan"
         *ngIf="view === 'scan'">
      <ion-toolbar color="orange">
        <ion-title>Scan or Swipe a Gift Card</ion-title>
      </ion-toolbar>
      <div>
        <div>
          <img src="assets/icon/gift_card_scan.svg">
          <label>Scan</label>
        </div>
        <label>or</label>
        <div>
          <img src="assets/icon/gift_card_swipe.svg">
          <label>Swipe</label>
        </div>
      </div>
    </div>
    <div class="gift-card-payment-modal__manual"
         *ngIf="view === 'manual'">
      <ion-toolbar color="orange">
        <ion-title>Enter the gift card number</ion-title>
      </ion-toolbar>
      <div>
        <ion-input type="text"
                   placeholder="Gift Card Number"
                   [(ngModel)]="identification_number"></ion-input>
      </div>
    </div>
    <div class="gift-card-payment-modal__secure"
         *ngIf="view === 'secure'">
      <ion-toolbar color="orange">
        <ion-title>Enter the secure code</ion-title>
      </ion-toolbar>
      <div>
        <p *ngIf="errorMessage">{{errorMessage}}</p>
        <ion-input type="password"
                   placeholder="Secure Code"
                   [(ngModel)]="secure_code"></ion-input>
      </div>
    </div>
    <div class="gift-card-payment-modal__summary"
         *ngIf="view === 'summary'">
      <ion-toolbar color="orange">
        <ion-title>Gift Card Information</ion-title>
      </ion-toolbar>
      <div>
        <ng-container *ngIf="giftCard; else giftCardNotFoundView">
          <ng-container *ngIf="!isValidGiftCard; else giftCardInformation">
            <p>Gift Card Has Expired</p>
            <p *ngIf="this.giftCard.expiry_date">Expiry Date: <b>{{ this.giftCard.expiry_date | date }}</b></p>
            <p>Balance: <b>{{ giftCard.balance | currency }}</b></p>
          </ng-container>

          <ng-template #giftCardInformation>
            <p>Your Gift Card has a balance of <b>{{ giftCard.balance | currency }}</b></p>
          </ng-template>
        </ng-container>
        <ng-template #giftCardNotFoundView>
          <h1>Gift Card not found</h1>
          <p *ngIf="isPayment">Please try again or select a different payment method.</p>
          <p *ngIf="!isPayment">Please try again.</p>
        </ng-template>
      </div>
    </div>
  </div>
</ion-content>
<ion-footer>
  <ion-toolbar mode="md"
               color="light">
    <ion-buttons slot="end">
      <ng-container [ngSwitch]="view">
        <ion-button *ngSwitchCase="GiftCardPaymentModalView.SCAN"
                    color="dark"
                    fill="solid"
                    debounce-click
                    [debounceTime]="0"
                    (debounceClick)="onManualEntry()">
          Manual Gift Card Entry
        </ion-button>

        <ion-button *ngSwitchCase="GiftCardPaymentModalView.MANUAL"
                    color="dark"
                    fill="solid"
                    [disabled]="!identification_number"
                    debounce-click
                    [debounceTime]="0"
                    (debounceClick)="onConfirmManualEntry()">
          Confirm Gift Card Number
        </ion-button>

        <ion-button *ngSwitchCase="GiftCardPaymentModalView.SECURE"
                    color="dark"
                    fill="solid"
                    [disabled]="!secure_code"
                    debounce-click
                    [debounceTime]="0"
                    (debounceClick)="onConfirmSecureCode()">
          Confirm Secure Code
        </ion-button>

        <ng-container *ngSwitchCase="GiftCardPaymentModalView.SUMMARY">
          <ion-button *ngIf="isPayment"
                      color="dark"
                      fill="solid"
                      [disabled]="!isValidGiftCard"
                      debounce-click
                      [debounceTime]="0"
                      (debounceClick)="onConfirmGiftCard()">
            Confirm Gift Card
          </ion-button>
        </ng-container>
      </ng-container>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>